import React from 'react';
import SpreadReadingPage from './SpreadReadingPage';

const config = {
  pickerPage: 'mindBodySpirit',
  path: '/mind-body-spirit-tarot/',
  spreadId: 'mindBodySpirit',
  cardCount: 3,
  metaTitle: 'Free Mind Body Spirit Tarot Spread Reading | NowTarot AI',
  metaDescription:
    'Get a free mind body spirit tarot reading. Draw 3 cards for your mental state, physical well-being, and spiritual path, and find where to restore balance. No signup.',
  metaKeywords:
    'mind body spirit tarot, mind body spirit tarot spread, wellness tarot reading, balance tarot spread, spiritual tarot reading, self care tarot',
  heading: 'Mind Body Spirit Tarot Reading',
  intro:
    'Feeling out of balance? This free mind body spirit tarot reading uses a three-card spread that checks in with every part of you: your thoughts, your physical well-being, and your spiritual path. It is a gentle way to see where you are thriving and where you need care. 100% free, no signup required.',
  howItWorks:
    'Take a few slow breaths and notice how you feel, then shuffle the deck and pick three cards. The first card reflects your mind and thoughts, the second your body and physical world, and the third your spirit and inner wisdom.',
  contentSections: [
    {
      heading: 'The Three Positions of the Mind Body Spirit Spread',
      items: [
        {
          title: 'Mind',
          text: 'Your mental state: the thoughts, worries, and beliefs taking up space right now. Swords cards here often point to overthinking; calmer cards suggest clarity.',
        },
        {
          title: 'Body',
          text: 'Your physical well-being and material world, including energy, rest, health habits, and home. Pentacles cards in this position tend to speak directly to the body and daily routines.',
        },
        {
          title: 'Spirit',
          text: 'Your spiritual path, intuition, and sense of meaning. This card shows whether you feel connected to something larger or need time to reconnect.',
        },
      ],
    },
    {
      heading: 'Reading the Balance Between the Cards',
      items: [
        {
          title: 'One Card Looks Heavy',
          text: 'If one position draws a difficult card while the others are calm, that area is asking for attention first. Start small: one change in the area that feels most out of balance.',
        },
        {
          title: 'All Three Feel Similar',
          text: 'When all three cards share a suit or mood, the same theme is running through your whole life right now. The suit tells you which element to work with.',
        },
        {
          title: 'Major Arcana Cards',
          text: 'A Major Arcana card in any position marks a bigger life lesson. The Star in Spirit, for example, suggests healing and renewed faith; The Tower in Mind suggests a belief is about to be overturned.',
        },
      ],
    },
  ],
  faqHeading: 'Mind Body Spirit Tarot FAQ',
  faq: [
    {
      question: 'What is a mind body spirit tarot spread?',
      answer:
        'It is a three-card spread where each card represents one part of you: your mind, your body, and your spirit. Reading them together shows where you are balanced and where you may need rest, care, or change.',
    },
    {
      question: 'Can tarot replace medical or mental health advice?',
      answer:
        'No. This reading is for reflection and entertainment. If a card brings up a health or mental health concern, please talk to a qualified professional.',
    },
    {
      question: 'How often should I do a mind body spirit reading?',
      answer:
        'Many people use it weekly or at the start of a new month as a check-in. It also works well during stressful periods when you feel pulled in many directions.',
    },
    {
      question: 'Is this mind body spirit tarot reading free?',
      answer:
        'Yes! This reading is 100% free with no signup or credit card required. For deeper, personalized guidance, ask our AI tarot reader in chat.',
    },
  ],
  crossLinks: (
    <>
      Want more? Pull a <a href="/daily-tarot-reading/" style={{ color: '#FFD700' }}>daily tarot card</a>, try the{' '}
      <a href="/six-card-tarot-spread/" style={{ color: '#FFD700' }}>6-card universal spread</a>, or explore{' '}
      <a href="/tarot-card-meanings/" style={{ color: '#FFD700' }}>the meaning of every tarot card</a> — all free, no signup required.
    </>
  ),
};

const MindBodySpiritTarot = () => <SpreadReadingPage config={config} />;

export default MindBodySpiritTarot;
